<template>
  <main style="opacity: 0; visibility: hidden;" :data-detail="`${hero.detail.country} . ${hero.detail.year}`">
    <Hero
      :data="hero"
      :next="next"
    />
    <Detail :data="data.details" />
    <Gallery :data="{ size: data.gallery , id: this.$route.params.id }" />
    <Next :data="next" />
  </main>
</template>

<script>
import Hero from '@/components/Hero.vue';
import Detail from '@/components/Detail.vue';
import Gallery from '@/components/Gallery.vue';
import Next from '@/components/Next.vue';

export default {
  name: 'Motorcycle',

  components: {
    Hero,
    Detail,
    Gallery,
    Next,
  },

  data() {
    return {
      data: this.$store.state.firebase.details[this.$route.params.id],
    };
  },

  mounted() {
    this.$store.commit('SET_DETAIL', this.$el.dataset.detail);
  },

  beforeDestroy() {
    this.$store.commit('SET_DETAIL', null);
  },

  computed: {
    hero() {
      const motorcycle = this.$store.state.firebase.motorcycles.find(el => el.id === this.$route.params.id);
      return motorcycle;
    },
    next() {
      const data = {};
      const { motorcycles } = this.$store.state.firebase;
      const current = motorcycles.find(el => el.id === this.$route.params.id);
      const order = motorcycles.filter(el => el.order === current.order + 1);
      const next = order.length > 0 ? order[0] : motorcycles.find(el => el.order === 0);

      data.id = next.id;
      data.name = next.name;
      data.brand = next.brand;
      data.image = `/static/images/${data.id}/00_${data.id}.jpg`;

      return data;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
